import React from 'react';
import moment from 'moment';
import ReactMoment from 'react-moment';

import { Tooltip } from './../../themes/default';

const FormatDate = ({ value, format }) => {

  let f = format !== undefined ? format : "DD/MM/YYYY";

  return(
    <Tooltip title={ <ReactMoment format={"LLL"}>{ value }</ReactMoment> }>
      <span><ReactMoment format={f}>{ value }</ReactMoment></span>
    </Tooltip>
  )

}

const formatDateToString = ({ value, format }) => {

  let f = format !== undefined ? format : "YYYY-MM-DD";

  return moment(value).format(f);

}

const momentDateToString = ({ value }) => {

  return moment(value).format("YYYY-MM-DD");

}

export { FormatDate, formatDateToString, momentDateToString };
